import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Brand from "@/components/Brand";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { XCircle } from "lucide-react";

const HOME = { admin: "/admin", therapist: "/painel", client: "/app" };

export default function PaymentCancel() {
  const navigate = useNavigate();
  const { user } = useAuth();
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <Card className="p-10 max-w-md w-full text-center">
        <Brand className="justify-center mb-8" />
        <div className="w-16 h-16 rounded-full bg-secondary flex items-center justify-center mx-auto"><XCircle className="w-9 h-9 text-muted-foreground" /></div>
        <h1 className="font-heading text-2xl font-semibold mt-5">Pagamento cancelado</h1>
        <p className="text-muted-foreground mt-2">Você cancelou o pagamento. Nenhum valor foi cobrado.</p>
        <Button className="rounded-full mt-6" onClick={() => navigate(HOME[user?.role] || "/")} data-testid="cancel-home-btn">Voltar ao painel</Button>
      </Card>
    </div>
  );
}
